import { type RouteLocation, type RouteRecordRaw } from 'vue-router';

import { ROUTE_DATA } from '@/constants/routes.constants';
import { routerHelper } from '@/services/router-helper';

const ErrorPage = (): unknown => {
    return import(/* webpackPrefetch: true */ './error-page.vue');
};

export const errorPageRoute: RouteRecordRaw = {
    ...ROUTE_DATA.ERROR_PAGE,
    components: {
        main: ErrorPage
    },
    props: {
        main(route: RouteLocation): { errorId?: number } {
            return { errorId: routerHelper.parseParamToInt(route.params.id as string) };
        }
    }
};
